import Helper from "./Helper";
import {CountUp} from '../../../node_modules/countup.js';

class Counter {
  constructor(config = {}) {
    const {
      container,
      classIn,
      classOut,
      langArray,
      decimalArray,
      thousandSepArray
    } = config;

    this.classIn = classIn;
    this.classOut = classOut;
    this.container = container;

    //variables for options
    this.decimal = '';
    this.separator = '';

    // handle multilang separators and decimals
    langArray.forEach((lang, index) => {
      if (document.documentElement.lang == lang) {
        this.decimal = decimalArray[index];
        this.separator = thousandSepArray[index];
      }
    });

    this.options = {
      startVal: 0, // number to start at (0)
      decimalPlaces: 0, // number of decimal places (0)
      duration: 4, // animation duration in seconds (2)
      useEasing: false,
      decimal: this.decimal,
      separator: this.separator
    };

    this.handleScroll();

    window.addEventListener("scroll", e => {
      this.handleScroll();
    });
  }


  handleScroll(){
    this.numberObj = [];
    this.numbers = document.querySelectorAll(this.container + ' .ns-keyfigure__number');
    this.numbersArray = Array.prototype.slice.call(this.numbers);
    this.numberObj = this.addNumbersToArray(this.numberObj, this.numbersArray);
    this.numbersArray.forEach((item, index)=>{
      this.addClassOnScroll(item, index, this.classIn, this.classOut);
      if(Helper.hasClass(item, 'is-in-viewport')){
        //console.log('hasClass');¨
        if(!Helper.hasClass(item, 'counting')){
          Helper.addClass(item, 'counting');
          this.options.decimalPlaces = this.getDecimal(item);
          const countUp = new CountUp(item, this.numberObj[index], this.options);
          
          countUp.start();
        }
      }
    });
  }

  addClassOnScroll(element, classIn, classOut){
    if (!Helper.isInViewport(element)) {
      element.classList.add(classIn);
      Helper.removeClass(element, classOut);
    } else {
      Helper.removeClass(element, classIn);
      Helper.addClass(element, classOut);
    }
  }

  getDecimal(item){
    //console.log(item);
    const a = item.innerText.split(this.decimal);
    let decimal = 0;
    if(a[1] != undefined){
      decimal = 1;
      if(a[1].toString().length === 2){
        decimal = 2;
      }
    }
    return decimal;
  }

  addNumbersToArray(obj, arr){
    arr.forEach((item)=>{
      let anumber = Number(item.innerHTML.replace('’', ''));
      obj.push(anumber);
    });
    return obj;
  }
}

export default Counter;
